import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import ErrorBoundary from "./components/ErrorBoundary";

// Handle Vite chunk load failures (happens after deploy when old cached HTML references stale chunks)
window.addEventListener('vite:preloadError', (event) => {
  // Prevent the default error from showing
  event.preventDefault();
  // Reload once to get fresh index.html with correct chunk references
  // Use a sessionStorage flag to avoid infinite reload loops
  const reloadKey = 'vite_chunk_reload';
  if (!sessionStorage.getItem(reloadKey)) {
    sessionStorage.setItem(reloadKey, '1');
    window.location.reload();
  } else {
    // Already reloaded once, clear flag and show error
    sessionStorage.removeItem(reloadKey);
  }
});

// Clear the reload flag on successful app load (after a short delay to ensure chunks loaded)
window.addEventListener('load', () => {
  sessionStorage.removeItem('vite_chunk_reload');
});

// Global error handlers
window.onerror = function(message, source, lineno, colno, error) {
  console.error('Global error:', { message, source, lineno, colno, error });
  document.body.innerHTML = `
    <div style="padding: 20px; font-family: Arial;">
      <h2>JavaScript Error</h2>
      <pre style="background: #f5f5f5; padding: 10px; overflow: auto;">${message}\n${source}:${lineno}:${colno}\n${error?.stack || ''}</pre>
      <button onclick="window.location.reload()" style="padding: 10px 20px; margin-top: 10px;">Reload</button>
    </div>
  `;
  return true;
};

window.addEventListener('unhandledrejection', function(event) {
  console.error('Unhandled promise rejection:', event.reason);
});

// Wrap initialization in try-catch
try {
  const root = document.getElementById("root");
  if (!root) {
    throw new Error("Root element not found");
  }
  
  createRoot(root).render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
} catch (error) {
  console.error('Failed to initialize app:', error);
  document.body.innerHTML = `
    <div style="padding: 20px; font-family: Arial;">
      <h2>Initialization Error</h2>
      <pre style="background: #f5f5f5; padding: 10px; overflow: auto;">${error instanceof Error ? error.message + '\n' + error.stack : String(error)}</pre>
      <button onclick="window.location.reload()" style="padding: 10px 20px; margin-top: 10px;">Reload</button>
    </div>
  `;
}
